export default __webpack_public_path__ + "static/media/pptLogo.a904e8d3.svg";